import {createContext, useContext, useState} from 'react'

export const LoaderContext = createContext({
    isLoading: false,
    setIsLoading: () => {},
})

export const LoaderProvider = ({children}) => {
    const [isLoading, setIsLoading] = useState(false)

    return (
        <LoaderContext.Provider value={{isLoading, setIsLoading}}>
            {children}
        </LoaderContext.Provider>
    )
}

export const useLoader = () => {
    const context = useContext(LoaderContext)

    if (!context) {
        throw new Error('useLoader must be used within a LoaderProvider')
    }

    return context
}
